import { useRouterHistory } from 'react-router';
import createHashHistory from 'react-router/node_modules/history/lib/createHashHistory';
const initHistory = () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const routeHistory = useRouterHistory(createHashHistory)({
    basename: ''
  });
  return routeHistory;
};
export default initHistory;
